<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="">
            <div class="row">
              <div class="col-md-12">
                <label>ATIVAR ESTOQUE 0.33</label>
                <select v-model="medicine_one_third" class="form-control">
                  <option value="NAO">NÃO</option>
                  <option value="SIM">SIM</option>
                </select>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "MedicineOneThird",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      medicine_one_third: "NAO",
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;

      const response = await api.get("/rest-home/settings/medicine-one-third");

      const { error, errors, medicine_one_third } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        this.medicine_one_third = medicine_one_third == 1 ? "SIM" : "NAO";
      }
    },

    async save() {
      try {
        this.loading = true;

        let { medicine_one_third } = this;

        if (medicine_one_third == "SIM") {
          medicine_one_third = 1;
        } else {
          medicine_one_third = null;
        }

        const data = { medicine_one_third };

        const response = await api.patch(
          "/rest-home/settings/medicine-one-third",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
